import ReportService from "../ReportService";
import DeliveryService from "../DeliveryService";

const Report = {
  formData(data) {
    let form = new FormData();
    for (let obj in data) {
      form.append(obj, data[obj]);
    }
    return form;
  },
  get(params) {
    var queryString = Object.keys(params)
      .map((key) => key + "=" + params[key])
      .join("&");
    return ReportService.get(`/delivery/orders?` + queryString);
  },
  dashboard(params) {
    var queryString = Object.keys(params)
      .map((key) => key + "=" + params[key])
      .join("&");
    return ReportService.get(`/delivery/dashboard?` + queryString);
  },
  heatmap(data) {
    return DeliveryService.post(`/console/report/location`, data);
  },
  location(data) {
    return DeliveryService.post(`/console/report/location`, data);
  },
  basket(data) {
    return DeliveryService.post(`/console/report/product`, data);
  },
  stock(data) {
    return DeliveryService.post(`/console/report/product_stock`, data);
  },
  packing(data) {
    return DeliveryService.post(`/console/report/product_to_pack`, data);
  },
  order_channel(data) {
    return DeliveryService.post(`/console/report/order-channel`, data);
  },
  logbook(data) {
    return DeliveryService.post(`/console/report/logbook`, data);
  },
  shop(data) {
    return DeliveryService.post(`/console/report/shop`, data);
  },
  category(data) {
    return DeliveryService.post(`/console/report/category`, data);
  },
  payments(data) {
    return DeliveryService.post(`/console/report/payments`, data);
  },
  payment_gateway(data) {
    return DeliveryService.post(`/console/report/payment_gateway`, data);
  },
  getLogbook(data) {
    return DeliveryService.post(`/console/report/logbook`, data);
  },
  memberShipTransation(params) {
    var queryString = Object.keys(params)
      .map((key) => key + "=" + params[key])
      .join("&");

    return ReportService.get(`/membership/transaction?` + queryString);
  },
  gpAdmin(params) {
    var queryString = Object.keys(params)
      .map((key) => key + "=" + params[key])
      .join("&");
    return DeliveryService.get(`/console/report/gp?` + queryString);
  },
  driverAdmin(params) {
    var queryString = Object.keys(params)
      .map((key) => key + "=" + params[key])
      .join("&");
    return DeliveryService.get(`/console/report/driver?` + queryString);
  },

  saleReport2025(data){
    return DeliveryService.post(`/console/report/payment-transactions?`, data);
  }
};

export default Report;
